import { ExternalLink } from 'lucide-react'

function timeStr(dateStr) {
  return new Date(dateStr).toLocaleString('en-ZA', {
    day: 'numeric', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit'
  })
}

export function InboxNotificationDetail({ notification, isDarkMode, onNavigate }) {
  return (
    <div className="p-6 max-w-xl">
      <div className="flex items-start gap-3 mb-4">
        <div className={`w-10 h-10 rounded-full flex-shrink-0 flex items-center justify-center text-sm font-bold ${
          isDarkMode ? 'bg-slate-600 text-slate-300' : 'bg-orange-100 text-sfp-orange'
        }`}>
          {(notification.title ?? 'N').charAt(0).toUpperCase()}
        </div>
        <div>
          <p className={`font-semibold ${isDarkMode ? 'text-slate-100' : 'text-sfp-darkgray'}`}>
            {notification.title ?? 'Notification'}
          </p>
          <p className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-gray-500'}`}>
            {timeStr(notification.created_at)}
          </p>
        </div>
      </div>

      {notification.message && (
        <p className={`text-sm mb-4 whitespace-pre-wrap ${isDarkMode ? 'text-slate-300' : 'text-gray-600'}`}>
          {notification.message}
        </p>
      )}

      {notification.task_id && (
        <button
          onClick={() => onNavigate('tasks', { taskId: notification.task_id })}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-sfp-orange text-white text-sm font-semibold hover:bg-orange-600 transition"
        >
          Go to Task
          <ExternalLink size={14} />
        </button>
      )}
    </div>
  )
}
